/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : dynamicTemplateAction.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";
const dynamicTemplateAction = {
  get_d_template: {
    api_name: "/SCM/templates/intersections/details",
    https_method: "GET",
    action_type: actionType.GET_DYNAMIC_TEMPLATE,
    description: "Get the Dynamic Forms In Settings",
  },
  add_d_template: {
    api_name: "/SCM/templates/intersections/add",
    https_method: "POST",
    action_type: actionType.ADD_DYNAMIC_TEMPLATE,
    description: "Add the Dynamic Forms In Settings",
  },
  update_d_template: {
    api_name: "/SCM/templates/intersections/details",
    https_method: "PUT",
    action_type: actionType.UPDATE_DYNAMIC_TEMPLATE,
    description: "Update the Dynamic Forms In Settings",
  },
  update_d_status_template: {
    api_name: "/SCM/templates/intersections/status",
    https_method: "PUT",
    action_type: actionType.UPDATE_STATUS_DYNAMIC_TEMPLATE,
    description: "Update Status the Dynamic Forms In Settings",
  },
};

export default dynamicTemplateAction;
